import React from 'react';
import { Phone, MessageSquareText } from 'lucide-react';
export function StickyMobileCTA() {
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 flex shadow-[0_-4px_10px_rgba(0,0,0,0.1)]" data-id="element-312">
      <a href="tel:7026425352" className="flex-1 bg-brand-navy text-white flex items-center justify-center gap-2 h-14 font-bold uppercase tracking-wide active:bg-brand-dark transition-colors" data-id="element-313">
        <Phone className="w-5 h-5" data-id="element-314" />
        <span data-id="element-315">Call Now</span>
      </a>
      <a href="#quote" className="flex-1 bg-brand-red text-white flex items-center justify-center gap-2 h-14 font-bold uppercase tracking-wide active:bg-brand-redDark transition-colors" data-id="element-316">
        <MessageSquareText className="w-5 h-5" data-id="element-317" />
        <span data-id="element-318">Get Quote</span>
      </a>
    </div>;
}